/* eslint-disable jira/filename-case */

import type { Store } from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import { createStore } from './createStore.tsx';
import type { State } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { State } from './types.tsx';

export const store: Store<State> = createStore();
